var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home lxn-w100"},[_c('div',{staticClass:"Home-main-wrapper lxn-w100 lxn-overflow-y-scroll lxn-overflow-x-hidden"},[_c('router-view')],1),_c('BottomNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }